import LocationsMap from './LocationsMap'
import LocationSelector from './LocationSelector'

export default function App() {
  return (
    <div>
      <LocationSelector />
      <div className="rounded overflow-clip">
        <div>
          <LocationsMap />
        </div>
      </div>
    </div>
  )
}
